module.exports = __webpack_public_path__ + "img/GALLERY-FRONX-BOOSTERGREEN-1.1f6e59aa.jpg";